import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import CashExpense, { Baraus, CashExpenseProps } from "./cashExpense";
import { SheetEventType } from "../../../siteManagement/sheet";
import { General } from "../../../siteManagement/general";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { DropDownList } from "../../core/components/dropDownList";
import { Button, ButtonProps } from "../../core/components/button";
import { OpenCopyCashExpenseDialog } from "./dialogs/copyCashExpenseDialog";
import { CashExpenseTranslation } from "./editLanguageSpecificParameters";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { Metadata } from "../../core/components/commonApp";
import React from "react"

export default class EditCashExpense extends React.Component<{ context: ContextGeneralSettingsApp }, EditCashExpenseState> {
    private gridOptions: any = null;
    private factory = ComponentHelper.createFactory();

    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            currentItem: null,
            idBaraus: null,
            barausDropDownDataSource: null,
            cashExpenseMetaData: null,
            usedLanguages: null
        };
    }

    componentDidMount() {
        this.gridOptions = this.props.context.cashExpenseGridOptions;

        //Alles in Chain
        this.loadGridData();
        this.loadCurrencyDropDownDataSource();
        this.loadCashExpenseMetaData();
        this.loadCashExpenseUsedLanguages();
    }

    private loadGridData = async () => {
        let url = "GeneralSettingsCashExpenses/GetAllCashExpenses";
        if (Helper.hasValue(this.state.idBaraus))
            url += "?idBaraus=" + encodeURIComponent(this.state.idBaraus);
        let result = await HTTPService.get<JsonResultClass<Baraus[]>>(url);
        if (result.Code == 0) {
            this.setState({ gridData: result.Data });
        }
    }

    private loadCurrencyDropDownDataSource = async () => {
        let result = await HTTPService.get<any[]>("GeneralSettingsCashExpenses/GetDistinctBarausIds");
        this.setState({ barausDropDownDataSource: result });
    }

    private loadCashExpenseMetaData = async () => {
        let result = await Helper.getMetaData("cashExpense");
        this.setState({ cashExpenseMetaData: result });
    }

    private loadCashExpenseUsedLanguages = async () => {
        let result = await HTTPService.get<JsonResultClass<CashExpenseTranslation[]>>("GeneralSettingsCashExpenses/GetUsedLanguages");
        this.setState({ usedLanguages: result.Data });
    }

    private openCashExpense = (baraus: Baraus) => {
        baraus.RecordRight = { CanRead: true, CanWrite: true };
        baraus.IsWatchable = true;
        baraus.IsWatched = true;

        const props: CashExpenseProps = {
            dataSources: {},
            metadata: this.state.cashExpenseMetaData,
            entity: baraus,
            isWindow: true,
            context: {},
            title: ""
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, (target) => {
            this.loadGridData();
            this.loadCurrencyDropDownDataSource();
        });

        sheet.show(() => {
            sheet.mountContent(CashExpense, props);
        });
    }

    private delete = async (dataItem: Baraus) => {
        let isOk = await DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"])
        if (isOk) {
            let url = "GeneralSettingsCashExpenses/DeleteCashExpense?nr=" + dataItem.Nr;
            if (Helper.hasValue(dataItem.IdBaraus))
                url += "&idBaraus=" + dataItem.IdBaraus;
            var result = await HTTPService.post<JsonResultClass>(url, { model: dataItem });
            if (result.Code == 0) {
                this.loadGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private restore = async (dataItem: Baraus) => {
        let url = "GeneralSettingsCashExpenses/RestoreCashExpense?nr=" + dataItem.Nr;
        if (Helper.hasValue(dataItem.IdBaraus))
            url += "&idBaraus=" + dataItem.IdBaraus;
        var result = await HTTPService.post<JsonResultClass>(url, { model: dataItem });
        if (result.Code == 0) {
            this.loadGridData();
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private getNewBaraus = (): Baraus => {
        let newBaraus: Baraus = {
            IsNew: true,
            IsWatchable: true,
            IsWatched: true,
            RecordRight: { CanRead: true, CanWrite: true },
            IdBaraus: this.state.idBaraus,
            CostFactor: null,
            InvoiceFactor: null,
            Quantity: 1,
            Translations: JSON.parse(JSON.stringify(this.state.usedLanguages))
        }
        return newBaraus;
    }

    private handleSelectedChange = (dataItem: Baraus) => {
        this.setState({ currentItem: dataItem });
    }

    private handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Baraus) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this.openCashExpense(dataItem);
                break;
            case (ToolBarStandardButtonType.NEW):
                let barausNew = this.getNewBaraus();
                this.openCashExpense(barausNew);
                break;
            case (ToolBarStandardButtonType.DELETE):
                this.delete(dataItem);
                break;
        }
    }

    private handleClickCustomButton = async (id: string, dataItem: Baraus, dataItems: Array<any>) => {
        switch (id) {
            case "copy":
                let newCashExpense = await OpenCopyCashExpenseDialog(dataItem);
                this.copy(newCashExpense);
                break;
            case "restore":
                this.restore(dataItem);
                break;
        }
    }

    private onDataBound = (e) => {
        var data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].Deleted) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", "#ef9a9a");
                cell.css("color", "#000000");
            }
        }
    }

    copy = async (entity: Baraus) => {
        let result = await HTTPService.post<JsonResultClass>("GeneralSettingsCashExpenses/Save", entity);
        if (result.Code === 0) {
            NotificationHelper.showSuccessMessage(result.Message);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private deleteId = async () => {
        let isOk = await DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"])
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass>("GeneralSettingsCashExpenses/DeleteMainGroupDependentBaraus?idBaraus=" + this.state.idBaraus);
            if (result.Code == 0) {
                this.setState({ idBaraus: null }, () => {
                    this.loadCurrencyDropDownDataSource();
                    this.loadGridData();
                });
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Ressource.LöschenErfolgreich"));
            }
            else
                NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private createDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.value = this.state.idBaraus;
        props.field.refreshDSOnRefChange = true;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.dataSource = this.state.barausDropDownDataSource;
        props.field.optionLabel = Helper.getTranslation("WebSMS.ResourcePlanningScheduler.FilterTemplates.Default");
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this.setState({ idBaraus: dataItem.Key }, this.loadGridData);
        }
        props.onDataLoaded = (field: { model: string }, data: any) => {
        }
        return (
            <FieldInstance label={Helper.getTranslation("Field.Barauslage.IdMainGroup")} noHover={true} labelStyle={{ width: "auto" }}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private createButton = () => {
        const props: ButtonProps = {
            handleClick: () => {
                let barausNew = this.getNewBaraus();
                barausNew.IdBaraus = null;
                barausNew.IsNewIdBaraus = true;
                this.openCashExpense(barausNew);
            },
            iconName: "plus",
            title: Config.translations.newLabel,
            buttonStyle: {
                marginLeft: "5px",
                marginTop: "5px"
            }
        }
        return <Button {...props} />
    }

    private deleteButton = () => {
        const props: ButtonProps = {
            handleClick: () => {
                this.deleteId();
            },
            iconName: "trash",
            title: Config.translations.deleteLabel,
            buttonStyle: {
                marginLeft: "5px",
                marginTop: "5px"
            },
            readOnly: this.state.idBaraus == null || this.state.idBaraus <= 0
        }
        return <Button {...props} />
    }

    private createGrid = () => {
        let isDeleted = Helper.hasValue(this.state.currentItem) && this.state.currentItem.Deleted;

        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: !isDeleted });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: !isDeleted });

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({ caption: Helper.getTranslation("WebSMS.GeneralSettings.CashExpenses.Restore"), enabled: isDeleted, iconClass: "fa-light fa-trash-arrow-up", id: "restore", autoEnabledOnRecordSelected: true });
        customButtons.push({ caption: Helper.getTranslation("Standard.Kopieren"), enabled: true, iconClass: "k-i-copy", id: "copy", autoEnabledOnRecordSelected: true });

        return <Grid data={this.state.gridData} options={this.gridOptions} id="generalSettings_CashExpensesGrid" onSelectionChanged={this.handleSelectedChange}
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} customButtons={customButtons} onClickCustomButton={this.handleClickCustomButton}
            onDataBound={this.onDataBound} />;
    }

    render() {
        const dropDown = this.createDropDown();
        let buttonNew = this.createButton();
        let buttonDelete = this.deleteButton();

        const grid = Helper.hasValue(this.state.gridData) && Helper.hasValue(this.gridOptions) ? this.createGrid() : null;
        return (
            <>
                <div style={{ display: "flex", flexDirection: "row", width: "auto" }}>
                    {dropDown}
                    {buttonNew}
                    {buttonDelete}
                </div>
                <div style={{ height: "450px" }}>
                    {grid}
                </div>
            </>);
    }
};


interface EditCashExpenseState {
    currentItem: Baraus;
    gridData: Baraus[];
    idBaraus: number;
    barausDropDownDataSource: any[];
    cashExpenseMetaData: Metadata;
    usedLanguages: CashExpenseTranslation[];
}